import { router, useLocalSearchParams } from "expo-router"
import FullScreenLoader from "@/components/loading/FullScreenLoaderDark"
import { H6 } from "@/components/standard/BFText"
import { useCombinedLoanData } from "@/queries/loan"
import { useEffect, useLayoutEffect } from "react"
import {
  type LoanApplication,
  useLoanContext,
  useNewLoanContext,
} from "@/screens/loans/components/LoanContext"
import { setLoanUpdates } from "@/stores/loanState"
import { NEW_LOAN_ID } from "@/app/(tabs)/loans/setup/_layout"
import {
  $preQual,
  convertPreQualToLoanApp,
  initPreQualFromLoanApplication,
  initPreQualFromProfile,
} from "@/stores/preQual"
import { useUser } from "@/queries/user"

function hasFinishedProductSetup(loan: LoanApplication) {
  if (!loan.contractStatus) {
    return false
  }

  if (
    !loan.afterRepairValue ||
    !loan.purchasePrice ||
    loan.afterRepairValue <= 0 ||
    loan.purchasePrice <= 0
  ) {
    return false
  }

  if (loan.contractStatus === "unknown") {
    return true
  }

  if (!loan.targetCloseDate) {
    return false
  }

  return !(loan.contractStatus === "refinance" && !loan.originalPurchaseDate)
}

function routeToScreen(loan: LoanApplication) {
  if (!hasFinishedProductSetup(loan)) {
    router.replace(`/loans/setup/property?_loanId=${loan.id}`)
    return
  }

  if (!loan.loanProduct) {
    router.replace(`/loans/setup/product?_loanId=${loan.id}`)
  }

  router.replace(`/loans/setup/submit?_loanId=${loan.id}`)
}

export default function NewLoanSetup() {
  const { loanId } = useLocalSearchParams<{ loanId?: string }>()
  const { setLoanId } = useNewLoanContext()
  const { update } = useLoanContext()
  const { data: userData } = useUser()
  const { data: loan } = useCombinedLoanData(loanId)

  useLayoutEffect(() => {
    setLoanUpdates(NEW_LOAN_ID, {})
  }, [])

  useEffect(() => {
    console.log("NewLoanSetup useEffect loanId", loanId)

    setLoanId(loanId!)
    if (loan?.loanApplication) {
      initPreQualFromLoanApplication(loan.loanApplication)
      routeToScreen(loan.loanApplication)
    }
  }, [loan])

  useEffect(() => {
    if (!loanId) {
      initPreQualFromProfile(userData?.me?.loanProfile || undefined)
      update(convertPreQualToLoanApp())
      console.log(userData?.me?.loanProfile, $preQual.get())
      router.replace("/loans/setup/qualifications")
    }
  }, [])

  return (
    <FullScreenLoader>
      <H6>Finding loan info</H6>
    </FullScreenLoader>
  )
}
